import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source"]

  static values = {
    text: String
  }

  async copy(event) {
    event?.preventDefault()

    const text = this.resolveText()

    if (!text) {
      this.showNotification("Ошибка копирования", "error")
      return
    }

    try {
      await this.writeToClipboard(text)
      this.showNotification("Скопировано")
    } catch (_error) {
      this.showNotification("Ошибка копирования", "error")
    }
  }

  resolveText() {
    if (this.hasTextValue && this.textValue.trim() !== "") {
      return this.textValue
    }

    if (!this.hasSourceTarget) {
      return ""
    }

    if ("value" in this.sourceTarget) {
      return this.sourceTarget.value.trim()
    }

    return this.sourceTarget.textContent.trim()
  }

  async writeToClipboard(text) {
    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(text)
        return
      } catch (_error) {
      }
    }

    if (!this.copyWithExecCommand(text)) {
      throw new Error("Copy failed")
    }
  }

  copyWithExecCommand(text) {
    const textarea = document.createElement("textarea")
    const activeElement = document.activeElement

    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "fixed"
    textarea.style.top = "0"
    textarea.style.left = "-9999px"
    textarea.style.opacity = "0"

    document.body.appendChild(textarea)
    textarea.focus()
    textarea.select()
    textarea.setSelectionRange(0, textarea.value.length)

    let copied = false

    try {
      copied = document.execCommand("copy")
    } finally {
      textarea.remove()

      if (activeElement?.focus) {
        activeElement.focus()
      }
    }

    return copied
  }

  showNotification(message, type = "success") {
    const notification = document.createElement("div")

    notification.textContent = message
    notification.className = [
      "fixed",
      "top-4",
      "right-4",
      "z-50",
      "rounded",
      "px-3",
      "py-2",
      "text-sm",
      "text-white",
      "shadow-lg",
      type === "success" ? "bg-green-600" : "bg-red-600"
    ].join(" ")

    document.body.appendChild(notification)

    setTimeout(() => {
      notification.remove()
    }, 1800)
  }
}